'use es6';

import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { track } from '../../utils/usageTracker';

const UsageViewTracker = ({
  active = true,
  name = 'pageview',
  properties = {}
}) => {
  const [tracked, setTracked] = useState(false);
  const getComputedProperties = useCallback(() => {
    return typeof properties === 'function' ? properties() : properties;
  }, [properties]);
  useEffect(() => {
    if (active && !tracked) {
      track(name, getComputedProperties());
      setTracked(true);
    }
  }, [active, getComputedProperties, name, tracked]);
  return null;
};

UsageViewTracker.propTypes = {
  active: PropTypes.bool,
  name: PropTypes.string,
  properties: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
export default UsageViewTracker;